import { render, staticRenderFns } from "./winwheel.vue?vue&type=template&id=e83f56ce&"
import script from "./winwheel.vue?vue&type=script&lang=js&"
export * from "./winwheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports